<template>
	<div class="c-network-cable-calculator t-margin-bottom-s">
		<div class="o-grid">
			<div data-size="sm:12 md:9 lg:9" class="o-grid__column">
				<fieldset class="t-margin-bottom-m">
					<div class="c-form__item">
						<dropdown-variations
							:item-groups="cableOptions"
							label="Kabel"
							:required="false"
							input-id="cableOptions"
							ref="cableOptions">
						</dropdown-variations>
					</div>
					<div class="c-form__item">
						<vue-input
							label="Omgivningstemp (Tambient) i °C"
							input-id="ambientTemp"
							ref="ambientTemp"
							:required="false"
							:text-input-should-behave-as-number="true">
						</vue-input>
					</div>
					<div class="c-form__item">
						<vue-input
							label="Kabelbuntstorlek (N) i st här"
							input-id="cableBundleSize"
							ref="cableBundleSize"
							:required="false"
							:no-decimal="true"
							:text-input-should-behave-as-number="true">
						</vue-input>
					</div>
					<div class="c-form__item">
						<dropdown-variations
							:item-groups="installationMethod"
							label="Installationsmetod"
							:required="false"
							input-id="installationMethod"
							ref="installationMethod">
						</dropdown-variations>
					</div>
					<div class="c-form__item">
						<vue-input
							label="Temperatur ökning i kabelbunt (ΔT) i °C"
							input-id="temperatureIncrease"
							:value="temperatureIncrease"
							type="text"
							:required="false"
							:readonly="true">
						</vue-input>
					</div>
				</fieldset>
				<fieldset>
					<div class="t-margin-bottom-m">
						<dropdown-variations
							:item-groups="totalCableLength"
							label="Total kablagelängd (Lcord) i m"
							:required="false"
							input-id="totalCableLength"
							ref="totalCableLength">
						</dropdown-variations>
						<span class="c-network-cable-calculator__extra--label">Korskopplings- & anslutnings-kablage</span>
					</div>
					<div class="c-form__item">
						<vue-input
							label="Temperatur (Tglobal) i °C"
							input-id="temperature"
							:value="temperature"
							type="text"
							:required="false"
							:readonly="true"
							:css-classes="temperature > 60 ? 'c-network-cable-calculator__indication' : ''">
						</vue-input>
					</div>
					<div class="c-form__item">
						<vue-input
							label="Längd på Permanent Länk (L) i m"
							input-id="lengthPermanentLink"
							:value="lengthPermanentLink"
							type="number"
							:required="false"
							:readonly="true"
							:css-classes="lengthPermanentLink > 100 ? 'c-network-cable-calculator__indication' : ''">
						</vue-input>
					</div>
				</fieldset>
				<div class="t-margin-bottom-s" v-if="errorText.length > 0">
					<p class="c-network-cable-calculator__error">{{errorText}}</p>
				</div>
				<div class="t-text-align-right">
					<button type="button" class="c-button c-button--primary" @click="updateValues">Räkna</button>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
import DropdownVariations from '@/components/vue-components/dropdown-variations/DropdownVariations.vue';
import VueInput from '@/components/vue-components/vue-input/VueInput.vue';

export default {
    name: 'NetworkCableCalculator',
    data() {
			return {
				cableOptions: [
					{
						items: [
							{
								id: "cable_1",
								group: "",
								name: "0,095 Ω/m, 5,0 mm"
							},
							{
								id: "cable_2",
								group: "",
								name: "0,075 Ω/m, 7,0 mm"
							},
							{
								id: "cable_3",
								group: "",
								name: "0,065 Ω/m, 7,7 mm"
							}
						]
					}
				],
				installationMethod: [
					{
						items: [
							{
								id: "method_1",
								group: "",
								name: "A: i isolering"
							},
							{
								id: "method_2",
								group: "",
								name: "B: i rör eller kanal"
							},
							{
								id: "method_3",
								group: "",
								name: "C: på operforerad kabelränna"
							},
							{
								id: "method_4",
								group: "",
								name: "E/F: Ventilerad (på krokar eller trådstege)"
							}
						]
					}
				],
				totalCableLength: [
					{
						items: [
							{
								id: "total_1",
								group: "",
								name: "10"
							},
							{
								id: "total_2",
								group: "",
								name: "15"
							},
							{
								id: "total_3",
								group: "",
								name: "20"
							}
						]
					}
				],
				temperature: '',
				temperatureIncrease: '',
				lengthPermanentLink: {
					type: Number,
					default: ''
				},
				matrix: {
					'20': {
						'10': 100,
						'15': 98,
						'20': 95
					},
					'25': {
						'10': 98,
						'15': 96,
						'20': 93
					},
					'30': {
						'10': 97,
						'15': 94,
						'20': 91
					},
					'35': {
						'10': 95,
						'15': 92,
						'20': 89
					},
					'40': {
						'10': 93,
						'15': 90,
						'20': 87
					},
					'45': {
						'10': 90,
						'15': 87,
						'20': 85
					},
					'50': {
						'10': 86,
						'15': 84,
						'20': 82
					},
					'55': {
						'10': 83,
						'15': 81,
						'20': 79
					},
					'60': {
						'10': 80,
						'15': 78,
						'20': 76
					}
				},
				errorText: {
					type: String,
					default: ''
				}
			}
    },
    components: {
			DropdownVariations,
			VueInput
	},
	methods: {
		updateValues() {
			let increasedTemperatureInCableBundle, heatParam, getTemperature;
			let cableOptions = this.$refs.cableOptions.getValue() ? this.$refs.cableOptions.getValue().name : '';
			let ambientTemp = this.$refs.ambientTemp.getValue() ? this.$refs.ambientTemp.getValue() : '';
			let cableBundleSize = this.$refs.cableBundleSize.getValue() ? this.$refs.cableBundleSize.getValue() : '';
			let installationMethod = this.$refs.installationMethod.getValue() ? this.$refs.installationMethod.getValue().name : '';
			let totalCableLength = this.$refs.totalCableLength.getValue() ? this.$refs.totalCableLength.getValue().name : '';
			this.errorText = '';
			this.lengthPermanentLink = '';
			this.temperature = '';

			// Depending on installationMethod, calculate increased temperature in cable bundle
			switch(installationMethod) {
				case 'A: i isolering':
					heatParam = 0.27;
					// case: A
					if (cableOptions === '0,095 Ω/m, 5,0 mm') {
						// cableOptions: 0,095
						increasedTemperatureInCableBundle = ((0.8 * cableBundleSize) + (heatParam * Math.sqrt(cableBundleSize)) / 0.005) * 0.095;
					} else if (cableOptions === '0,075 Ω/m, 7,0 mm') {
						// cableOptions: 0,075
						increasedTemperatureInCableBundle = ((0.8 * cableBundleSize) + (heatParam * Math.sqrt(cableBundleSize)) / 0.007) * 0.075;
					} else if (cableOptions === '0,065 Ω/m, 7,7 mm') {
						// cableOptions: 0,065
						increasedTemperatureInCableBundle = ((0.8 * cableBundleSize) + (heatParam * Math.sqrt(cableBundleSize)) / 0.0077) * 0.065;
					}
					break;
				case 'B: i rör eller kanal':
					// case: B
					heatParam = 0.12;
					if (cableOptions === '0,095 Ω/m, 5,0 mm') {
						// cableOptions: 0,095
						increasedTemperatureInCableBundle = ((0.8 * cableBundleSize) + (heatParam * Math.sqrt(cableBundleSize)) / 0.005) * 0.095;
					} else if (cableOptions === '0,075 Ω/m, 7,0 mm') {
						// cableOptions: 0,075
						increasedTemperatureInCableBundle = ((0.8 * cableBundleSize) + (heatParam * Math.sqrt(cableBundleSize)) / 0.007) * 0.075;
					} else if (cableOptions === '0,065 Ω/m, 7,7 mm') {
						// cableOptions: 0,065
						increasedTemperatureInCableBundle = ((0.8 * cableBundleSize) + (heatParam * Math.sqrt(cableBundleSize)) / 0.0077) * 0.065;
					}
					break;
				case 'C: på operforerad kabelränna':
					// case: C
					heatParam = 0.0772;
					if (cableOptions === '0,095 Ω/m, 5,0 mm') {
						// cableOptions: 0,095
						increasedTemperatureInCableBundle = ((0.8 * cableBundleSize) + (heatParam * Math.sqrt(cableBundleSize)) / 0.005) * 0.095;
					} else if (cableOptions === '0,075 Ω/m, 7,0 mm') {
						// cableOptions: 0,075
						increasedTemperatureInCableBundle = ((0.8 * cableBundleSize) + (heatParam * Math.sqrt(cableBundleSize)) / 0.007) * 0.075;
					} else if (cableOptions === '0,065 Ω/m, 7,7 mm') {
						// cableOptions: 0,065
						increasedTemperatureInCableBundle = ((0.8 * cableBundleSize) + (heatParam * Math.sqrt(cableBundleSize)) / 0.0077) * 0.065;
					}
					break;
				case 'E/F: Ventilerad (på krokar eller trådstege)':
					// case: D
					heatParam = 0.0578;
					if (cableOptions === '0,095 Ω/m, 5,0 mm') {
						// cableOptions: 0,095
						increasedTemperatureInCableBundle = ((0.8 * cableBundleSize) + (heatParam * Math.sqrt(cableBundleSize)) / 0.005) * 0.095;
					} else if (cableOptions === '0,075 Ω/m, 7,0 mm') {
						// cableOptions: 0,075
						increasedTemperatureInCableBundle = ((0.8 * cableBundleSize) + (heatParam * Math.sqrt(cableBundleSize)) / 0.007) * 0.075;
					} else if (cableOptions === '0,065 Ω/m, 7,7 mm') {
						// cableOptions: 0,065
						increasedTemperatureInCableBundle = ((0.8 * cableBundleSize) + (heatParam * Math.sqrt(cableBundleSize)) / 0.0077) * 0.065;
					}
					break;
			}

			// Set value of temperature increase
			if(increasedTemperatureInCableBundle) {
				// Round up increased temperature in cable bundle to one decimal
				this.temperatureIncrease = Math.round(increasedTemperatureInCableBundle * 10) / 10;
			} else {
				this.temperatureIncrease = '';
			}

			// Get total temperature with increased temperature in cable bundel and ambient temperature
			if (increasedTemperatureInCableBundle && (parseFloat(ambientTemp.replace(/,/g, '.')) > 0)) {
				// Round up increased temperature in cable bundle plus ambient temperature to one decimal
				this.temperature = Math.round((increasedTemperatureInCableBundle + parseFloat(ambientTemp.replace(/,/g, '.'))) * 10) / 10;
			} else {
				this.temperature = null;
			}

			if (this.temperature && totalCableLength) {
				if(this.temperature > 60) {
					this.lengthPermanentLink = '';
					this.errorText = 'Temperaturen överstiger 60°. Vänligen ändra dina parametrar.';
				} else {
					getTemperature = this.temperature;
					getTemperature = String(Math.ceil(getTemperature / 5) * 5);
					this.lengthPermanentLink = this.matrix[getTemperature][totalCableLength] - totalCableLength;
				}
			}
		},
	}
}
</script>
